<template>

  <div class="tournamentScreens">

      <div class="wrapper" :style="'zoom: ' + zoom + ' !important;'">
          <div class="head">            
              <table>
              <tbody>
                  <tr>
                  <td style="white-space: nowrap">
                      <h1>
                          {{ tournamentName }}<span class="logo" :style="{ backgroundImage: 'url(' + logoImg + ')' }"></span>
                      </h1>
                      <h2 v-if="roundIndex > 0">{{ prizename }}: {{$t('round')}} {{ roundIndex }} - {{ $t('pl'+playForm) }} {{ $t('sm'+scoringMode) }}</h2>
                  </td>
                  <td width="1100" valign="bottom">
                      <div class="ticker-container">                  
                      <marquee-text class="ticker-text" :key="currentTicker.id" :duration="8" :repeat="15">
                          {{ currentTicker.tickerText }}&nbsp; &nbsp; &nbsp; 
                      </marquee-text>
                      </div>
                  </td>
                  </tr>
              </tbody>
              </table>
          </div>
  
          <div class="tableHead">
              <table>
              <colgroup>
                  <col style="width:80px;">
                  <col>
                  <col style="width:120px;">
              </colgroup> 
                  <tbody><tr>
              <th>POS</th>
              <th class="left">{{$t('playerName')}}</th>
              <th>TOTAL</th>
              </tr>
              </tbody></table>
          </div>
  
          <div v-for="item in topPlayerPage" :key="item" >
              <div class="row" style="position: relative;">
                  <div class="content" style="position: absolute; top: 0px; left: 40px; z-index: 99; backface- visibility: visible;">
                      <table >
                          <colgroup style="visibility: hidden;"><col style="width: 80px; visibility: hidden;"><col style="visibility: hidden;"><col style="width: 120px; visibility: hidden;">
                          </colgroup> 
                          <tbody ><tr >
                          <td :class='(item.isWinner ? "winner" : "")' >
                            <ion-icon v-if="item.isWinner" :ios="trophyOutline" :md="trophyOutline"></ion-icon>
                            {{item.rank}}
                          </td>
                          <td :class='"left " + (item.isWinner ? "winner" : "")' > 
                              {{item.name}}
                          </td>
                           <td class="totalScore " >{{item.totalScore}} </td>
                          </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
          <div class="borderBottom"></div>
          <div v-for="item in displayPage" :key="item" >
              <div class="row" style="position: relative;">
                  <div class="content" style="position: absolute; top: 0px; left: 40px; z-index: 99; backface- visibility: visible;">
                      <table >
                          <colgroup style="visibility: hidden;"><col style="width: 80px; visibility: hidden;"><col style="visibility: hidden;"><col style="width: 120px; visibility: hidden;">
                          </colgroup> 
                          <tbody ><tr >
                          <td :class='(item.isWinner ? "winner" : "")' >
                          {{item.rank}}</td>
                          <td :class='"left " + (item.isWinner ? "winner" : "")' > 
                              {{item.name}}
                          </td>               
                          <td class="totalScore " >{{item.totalScore}} </td>
                          </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
  
          <div class="foot_liga" :style="{ background: '#e4e7ea url(' + footerImg + ') center center / 550px no-repeat' }">             
              <span>{{ associationName }}<br />{{ lastUpdate }}</span>
              <span v-if="isPaused==true" class="clicker">
                  <ion-icon :ios="playOutline" :md="playOutline" @click="isPaused = !isPaused"></ion-icon>
              </span>
              <span v-else class="clicker">
                  <ion-icon :ios="pauseOutline" :md="pauseOutline" @click="isPaused = !isPaused"></ion-icon>
              </span>
          </div>
      </div>
 
  </div>
  </template>
  
  
  <script>
  import { IonIcon } from '@ionic/vue';
  import { defineComponent, computed, ref, watch,getCurrentInstance } from 'vue';
  import { useQuery } from '@vue/apollo-composable'
  
  import findTournamentResultListQueryFile from '../graphql/findTournamentResultList.query.gql'
  import { useRoute } from 'vue-router';
  import { pauseOutline, trophyOutline } from 'ionicons/icons';
  import MarqueeText from 'vue-marquee-text-component'
  
  
  export default defineComponent({
    name: 'TournamentResultList',
    components: {
      IonIcon,
      MarqueeText
    },
    setup() {
      const route = useRoute()
      const app = getCurrentInstance()
      const changeLanguage = app.appContext.config.globalProperties.$changeLanguage
  
      var isPaused = ref(false)
      let topPlayerPage = ref([])
      let displayPage = ref([])
      let nextPageIntervalId = ref(0)
      var allItems = ref([])
      var parsHeader = ref([])
      var parsOUTHeader = ref(0)
      var parsINHeader = ref(0)
      var page = ref(0)
      var perPage = ref(10)
      var pages = ref([])
      var switchURL = ref(route.query.switchURL)
      var switchTournaments = ref(route.query.switchTournaments)
  
      const {  result: findTournamentResultListResult, refetch: findTournamentResultListRefetch, loading: findTournamentResultListLoading} = useQuery(findTournamentResultListQueryFile, () => ({ round_id: parseInt(route.params.roundid), prize_id: parseInt(route.params.prizeid), switchURL: switchURL?.value? parseInt(route.query.switchURL) : 0, switchTournaments: switchTournaments?.value?parseInt(route.query.switchTournaments):0}), () => ({ fetchPolicy: 'no-cache', enabled: route.params.roundid != undefined && route.params.prizeid != undefined } ))
  
      const currentTicker = computed(() => findTournamentResultListResult.value?.findTournamentResultList.currentTicker ?? '')
      const showDuration = computed(() => findTournamentResultListResult.value?.findTournamentResultList.showDuration ?? 10)
      const maxPages = computed(() => findTournamentResultListResult.value?.findTournamentResultList.maxPages ?? 1000)
      const topPlayers = computed(() => findTournamentResultListResult.value?.findTournamentResultList.topPlayers ?? 0)
      const footerImg = computed(() => findTournamentResultListResult.value?.findTournamentResultList.footerImg ?? '')
      const logoImg = computed(() => findTournamentResultListResult.value?.findTournamentResultList.logoImg ?? '')
      const tournamentName = computed(() => findTournamentResultListResult.value?.findTournamentResultList.tournamentName ?? '')
      const prizename = computed(() => findTournamentResultListResult.value?.findTournamentResultList.prizename ?? '')
      const roundIndex = computed(() => findTournamentResultListResult.value?.findTournamentResultList.roundIndex ?? 0)
      const roundPlayFormDescription = computed(() => findTournamentResultListResult.value?.findTournamentResultList.roundPlayFormDescription ?? '')
      const playForm = computed(() => findTournamentResultListResult.value?.findTournamentResultList.playForm ?? 0)
      const scoringMode = computed(() => findTournamentResultListResult.value?.findTournamentResultList.scoringMode ?? 0)
      const associationName = computed(() => findTournamentResultListResult.value?.findTournamentResultList.associationName ?? '')
      const lastUpdate = computed(() => findTournamentResultListResult.value?.findTournamentResultList.lastUpdate ?? '')
      const lang = computed(() => findTournamentResultListResult.value?.findTournamentResultList.lang ?? 'de')
      const livescoringNextLink = computed(() => findTournamentResultListResult.value?.findTournamentResultList.livescoringNextLink ?? '')
      const nextTournamentRoundId = computed(() => findTournamentResultListResult.value?.findTournamentResultList.nextTournamentRoundId ?? 0)
      const rounds = computed(() => findTournamentResultListResult.value?.findTournamentResultList.rounds ?? [])
      const players = computed(() => findTournamentResultListResult.value?.findTournamentResultList.players ?? [])
      const zoom = computed(() => findTournamentResultListResult.value?.findTournamentResultList.zoom ?? '100%')
  
      watch(lang, (newVal, oldVal) => {
        changeLanguage(newVal)
      })
  
      watch(livescoringNextLink, (newVal, oldVal) => {
        if(newVal && newVal != '' && switchURL?.value == 1 && window.location.href != newVal){
              window.location.href=newVal
          }
      }) 
      
      watch(players, (newVal, oldVal) => {   
          parsHeader.value = newVal[0]?.pars ?? [] 
          
          topPlayerPage.value = newVal.slice(0, topPlayers.value)
          allItems.value = newVal.slice(topPlayers.value)
  
          clearInterval(nextPageIntervalId.value)
          displayPage.value = allItems.value.slice(0, perPage.value-topPlayers.value)
          nextPageIntervalId.value = setInterval(() => {
              if (!isPaused.value)
                  page.value++;
  
              if (page.value * (perPage.value-topPlayers.value) >= allItems.value.length || page.value >= maxPages.value) {
                  if(switchTournaments?.value == 1 && nextTournamentRoundId.value != 0 ){
                      window.location.href= window.location.href.replace(route.params.roundid, nextTournamentRoundId.value)
                  }else{
                      page.value = 0
                      findTournamentResultListRefetch()
                  }
              }
              else
              displayPage.value = allItems.value.slice(page.value * (perPage.value-topPlayers.value), page.value * (perPage.value-topPlayers.value) + (perPage.value-topPlayers.value))
  
          }, showDuration.value * 1000)
      })
  
      watch(parsHeader, (newVal, oldVal) => {
          parsOUTHeader.value = newVal[0]+newVal[1]+newVal[2]+newVal[3]+newVal[4]+newVal[5]+newVal[6]+newVal[7]+newVal[8]
          parsINHeader.value = newVal[9]+newVal[10]+newVal[11]+newVal[12]+newVal[13]+newVal[14]+newVal[15]+newVal[16]+newVal[17]
      })
  
      function itemsToFillUpArray(arrayLength, perPage) {
        if(arrayLength%perPage!=0){
          return perPage-arrayLength%perPage
        }
        return 0;
      }
  
      return {
        pauseOutline, parsHeader, parsOUTHeader, parsINHeader,
        page, perPage, pages, showDuration, lastUpdate,associationName,      
        findTournamentResultListRefetch, findTournamentResultListLoading,
        maxPages, topPlayers, trophyOutline,
        logoImg, footerImg,currentTicker, 
        tournamentName, roundIndex, roundPlayFormDescription, playForm, 
        rounds, players, prizename, scoringMode, 
        allItems, displayPage, topPlayerPage, isPaused, zoom
      }
    },
    mounted(){    
    },
    methods: {
      setScoreColor(par, score){
          
          var classes = 'holeNumber '
          if(score == 0){
              
          } else if (par-score === 3) {
              classes += 'albatros';
          } else if (par-score  === 2) {
              classes += 'eagle';
          } else if (par-score  === 1) {
              classes += 'birdie';
          } else if (par-score  === 0) {
              classes += 'par';
          } else if (par-score  === -1) {
              classes += 'bogey';
          } else if (par-score  <= -2) {
              classes += 'doublebogey';
          } else if (par-score  <= -3) {
              classes += 'triplebogey';
          }
  
        return classes;
      },
      setScore(score){
          if(score==0)
              return '-'
          return score
      },
      getSign(score) {
        return score == 0 ? '' : score > 0 ? '+' : ''
      },
      getPlusSign(score) {
        if (score == 0)
          return 'Par'
        return score > 0 ? '+' + score : score
      },
    }
  });
  
  
  </script>
  
  <style scoped>
  
  /* ############## tournament-screens.css ###########*/
  
  .tournamentScreens {
    box-sizing: border-box;
    height: 100%;
    zoom: 80%;
  }
  
  .tournamentScreens {
    font: 14px/1.5 Helvetica, Helvetica, Tahoma, Verdana, sans-serif;
    color: #333;
    background: #000 right center /
      cover no-repeat fixed;
  }
  
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
  
  .cf:after {
    content: "";
    display: table;
    clear: both;
  }
  
  .tournamentScreens div.wrapper {
    width: 1600px;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -800px;
    margin-top: -382px;
    height: 815px;
    box-shadow: 0 0 100px 0 rgba(255, 255, 255, 0.3);
    border-radius: 25px;
    overflow: hidden;
    zoom: 100%
  }
  
  .tournamentScreens div.tournamentList {
    height: 686px;
    overflow: auto;
    background: rgba(255, 255, 255, 0.85);
  }
  
  .tournamentScreens div.tournamentList table {
    border-collapse: separate;
    width: 100%;
  }
  
  .tournamentScreens div.tournamentList thead th {
    font-weight: normal;
    font-size: 25px;
    text-align: left;
  }
  
  .tournamentScreens div.tournamentList tbody td {
    border: solid 1px #fff;
  }
  
  .tournamentScreens div.tournamentList tbody td:first-of-type {
    border-left: none;
  }
  
  .tournamentScreens div.tournamentList tbody td:last-of-type {
    border-right: none;
  }
  
  .tournamentScreens div.tournamentList a {
    white-space: nowrap;
    color: #009ee0;
  }
  
  .tournamentScreens div.tournamentList table td,
  .tournamentScreens div.tournamentList table th {
    padding: 5px;
  }
  
  .tournamentScreens div.row {
    height: 64px;
    padding: 0px; /* Dung: added */
  }
  
  .tournamentScreens div.row.club {
    height: 40px;
  }
  
  .tournamentScreens div.row.team {
    height: 84px;
  }
  
  .tournamentScreens div.head {
    height: 100px;
    padding: 15px 25px;
    background: rgba(0, 0, 0, 0.5);
    position: relative;
  }
  
  .tournamentScreens div.head span.logo {
    display: block;
    height: 50px;
    width: 200px;
    position: absolute;
    top: 25px;
    right: 25px;
    background: transparent no-repeat top left;
    background-size: contain;
  }
  
  .tournamentScreens div.head h1,
  .tournamentScreens div.head h2 {
    margin: 0;
    font-weight: normal;
  }
  
  .tournamentScreens div.head h1 {
    color: #ffe600;
  }
  
  .tournamentScreens div.head h2 {
    color: #fff;
  }
  
  .tournamentScreens div.tableHead,
  .tournamentScreens div.tournamentList table thead tr {
    height: 50px;
    background: #ffe600;
    color: #009ee0;
    padding: 0 25px;
  }
  
  .tournamentScreens div.content {
    color: #fff;
    background: rgba(0, 158, 224, 0.9);
    width: 1680px;
    margin-left: -40px;
    height: 64px;
    padding: 0 35px;
    font-size: 30px;
    box-shadow: inset 0 5px 10px 0 rgba(255, 255, 255, 0.4);
    border-bottom: solid 4px #000;
  }
  
  .tournamentScreens div.content.club {
    height: 40px;
  }
  
  .tournamentScreens div.content.team {
    height: 84px;
  }
  
  .tournamentScreens div.content.club {
    background: #009ee0;
    box-shadow: none;
  }
  
  .tournamentScreens div.content.club table {
    height: 40px;
    border: none;
  }
  
  .tournamentScreens div.content.club td {
    color: #ffe600;
    vertical-align: top;
    border: none;
    padding: 0 5px;
  }
  
  .tournamentScreens div.content.winner td {
    font-weight: bold;
    color: #ffe600;
  }
  
  .tournamentScreens div.content td.players {
    padding-left: 80px;
  }
  
  .tournamentScreens div.content img {
    display: inline-block;
    margin-top: -5px;
    vertical-align: middle;
  }
  
  .tournamentScreens div.tableHead table,
  .tournamentScreens div.row table {
    height: 100%;
    table-layout: fixed;
    border-collapse: separate;
    width: 100%;
  }
  
  .tournamentScreens div.content table {
    width: 1550px;
    margin: 0 auto;
    border-left: solid 2px #000;
    border-right: solid 2px #000;
  }
  
  .tournamentScreens div.row td,
  .tournamentScreens div.tableHead th {
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    font-size: 24px;
    white-space: nowrap;
    font-weight: normal;
    padding: 0px;
  }
  
  .tournamentScreens div.row td {
    border-left: solid 2px #000;
    border-right: solid 2px #000;
  }
  
  .tournamentScreens div.row .totalScore {
    font-weight: bold;
    color: #ffe600;
  }
  
  .tournamentScreens div.row td span.score {
    padding-left: 5px;
    font-weight: bold;
  }
  
  .tournamentScreens div.row td span.score,
  .tournamentScreens div.row td span.strokes {
    display: inline-block;
    width: 45%; /* Dung: changed old: 50% */
    text-align: center;
  }
  
  .tournamentScreens div.row td span.scorenotfinishedleft {
    display: inline-block;
    width: 50%;
    text-align: center;
    font-weight: bold;
    color: #169a19;
    padding-right: 5px;
    border-right: solid 2px #169a19;
  }
  
  .tournamentScreens div.row td span.scorenotfinishedright {
    display: inline-block;
    width: 50%;
    text-align: center;
    padding-left: 5px;
    font-weight: bold;
    color: #169a19;
    padding-right: 5px;
    border-left: solid 2px #169a19;
  }
  
  .tournamentScreens div.row td.winner {
    color: #ffe600;
    font-weight: bold;
  }
  
  .tournamentScreens div.row td span.strokes {
    border-right: solid 2px rgba(0, 0, 0, 0.5);
    padding-right: 5px;
    font-weight: bold;
  }
  
  .tournamentScreens div.row td span.strokes.hole {
    font-weight: normal;
  }
  
  .tournamentScreens div.row td.left,
  .tournamentScreens div.tableHead th.left {
    text-align: left;
  }
  
  .tournamentScreens div.row td.right,
  .tournamentScreens div.tableHead th.right {
    text-align: right;
  }
  
  .tournamentScreens div.foot {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: -4px;
    height: 29px;
    color: #fff;
    padding: 0 25px;
    line-height: 29px;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .tournamentScreens div.foot_liga {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: -4px;
    height: 29px;
    color: #fff;
    padding: 0 25px;
    line-height: 29px;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .tournamentScreens div.foot_faldo {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: -4px;
    height: 29px;
    color: #fff;
    padding: 0 25px;
    line-height: 29px;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .tournamentScreens div.foot_berlin {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: -4px;
    height: 29px;
    color: #fff;
    padding: 0 25px;
    line-height: 29px;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .tournamentScreens div.yearSelect {
    padding: 5px;
  }
  
  .tournamentScreens div.tournamentList div.error {
    padding: 30px;
  }
  
  .linkBuilder {
    font-size: 12px;
  }
  
  .linkBuilder div.wrapper {
    padding: 50px;
    width: 920px;
    margin: 0 auto;
  }
  
  .linkBuilder div.tournamentSelect input {
    width: 100%;
  }
  
  .linkBuilder div.linkBox {
    background: #e8e8e8;
    padding: 20px;
    margin-bottom: 2em;
  }
  
  .linkBuilder div.left,
  .linkBuilder div.right {
    width: 47.5%;
  }
  
  .linkBuilder div.left {
    margin-right: 55%;
  }
  
  .linkBuilder div.right {
    float: right;
  }
  
  .linkBuilder div.holder {
    padding-bottom: 5px;
    border-bottom: solid 2px #e8e8e8;
    margin-bottom: 5px;
  }
  
  .linkBuilder div.holder span.round {
    display: inline-block;
    overflow: hidden;
  }
  
  .linkBuilder div.left div.holder span.round {
    width: 360px;
  }
  
  .linkBuilder div.right div.holder span.round {
    width: 320px;
  }
  
  .linkBuilder i.control {
    font-size: 16px;
    display: inline-block;
    margin-right: 5px;
    float: right;
    cursor: pointer;
    color: #7f7f7f;
  }
  
  .linkBuilder div.right p {
    margin-top: 0;
    text-align: right;
  }
  
  .eagle {
    background: #f49183 !important;
  }
  
  .birdie {
    background: #eacebd !important;
  }
  
  .par {
    background: #b8e0c2 !important;
  }
  
  .bogey {
    background: #c2d3ec !important;
  }
  
  .doublebogey {
    background: #a1acbc !important;
  }
  
  .triplebogey {
    background: #60608c !important;
  }
  
  .albatros {
    background: #ede9c8 !important;
  }
  
  .borderBottom {
    border-bottom: solid 3px #000;
    border-color: black;
    margin-bottom: 1px;
  }
  
  /* ############## ticker.css ###########*/
  .ticker-container {
    border: 0px solid;
    overflow: hidden;
    margin-left: 0px;
    margin-right: 0px;
    color: red;
  }
  
  .ticker-text {
    height: 150%;
    font-size: 24px;
    white-space: nowrap;
    margin-top: 56px; /* Dung: added */
  }
  
  /* ############## overrides.css ###########*/
  
  .teetimeMobile dark {
    background: transparent !important;
    color: #000 !important;
  }
  
  .tournamentScreens {
    font: 17px/1.5 Helvetica, Helvetica, Tahoma, Verdana, sans-serif;
    color: #000;
    background: #fff;
  }
  
  .tournamentScreens div.wrapper {
    background: transparent;
    border: solid 2px #e4e7ea;
    height: 853px;
    margin-top: -427px;
  }
  
  .tournamentScreens div.tournamentList {
    background: #fff;
  }
  
  .tournamentScreens div.tournamentList tbody td {
    border: solid 1px #e4e7ea;
  }
  
  .tournamentScreens div.tournamentList tbody td:first-of-type {
    border-left: solid 2px #e4e7ea;
  }
  
  .tournamentScreens div.tournamentList tbody td:last-of-type {
    border-right: solid 2px #e4e7ea;
  }
  
  .tournamentScreens div.tournamentList a {
    color: #000;
    text-decoration: none;
  }
  
  .tournamentScreens div.tournamentList a:hover {
    color: #6e7a8b;
  }
  
  .tournamentScreens div.tournamentList a:active {
    color: #1f355e;
  }
  
  .tournamentScreens div.head {
    background: #e4e7ea;
  }
  
  .tournamentScreens div.head h1 {
    color: #1f355e;
  }
  
  .tournamentScreens div.head h2 {
    font-size: 25px;
    font-weight: 400;
    color: #000;
  }
  
  .tournamentScreens div.head span.logo {
    background-position: top right;
  }
  
  .tournamentScreens div.tableHead,
  .tournamentScreens div.tournamentList table thead tr {
    background: #bcc4cb;
    color: #1f355e;
  }
  
  .tournamentScreens div.content {
    color: #000;
    background: transparent;
    box-shadow: none;
    border-bottom: solid 2px #e4e7ea;
  }
  
  .tournamentScreens div.content img {
    display: inline-block;
    margin-top: -5px;
    vertical-align: middle;
  }
  
  .tournamentScreens div.content table {
    border-left: none;
    border-right: none;
  }
  
  .tournamentScreens div.row td {
    border-left: solid 1px #e4e7ea;
    border-right: solid 1px #e4e7ea;
  }
  
  .tournamentScreens div.row td:first-of-type {
    border-left: solid 2px #e4e7ea;
  }
  
  .tournamentScreens div.row td:last-of-type {
    border-right: solid 2px #e4e7ea;
  }
  
  .tournamentScreens div.foot {
    background: #e4e7ea
      center center / 640px no-repeat;
    color: #000;
    height: 60px;
  }
  
  .tournamentScreens div.foot_liga {
    color: #000;
    height: 60px;
  }
  
  .tournamentScreens div.yearSelect {
    border: solid 2px #e4e7ea;
  }
  
  .tournamentScreens div.head {
    position: static;
  }
  
  .tournamentScreens div.content.winner td {
    color: #79869e;
  }
  
  .tournamentScreens span.clicker {
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 150px;
  }
  
  .tournamentScreens div.row td.winner {
    color: #009ee0;
    font-weight: bold;
  }
  
  .tournamentScreens div.row .totalScore {
    font-weight: bold;
    color: #009ee0;
  }
  
  /* ############## normalize.css ###########*/
  /*! normalize.css v3.0.2 | MIT License | git.io/normalize */
  html {
    font-family: sans-serif;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }
  body {
    margin: 0;
  }
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }
  audio,
  canvas,
  progress,
  video {
    display: inline-block;
    vertical-align: baseline;
  }
  audio:not([controls]) {
    display: none;
    height: 0;
  }
  [hidden],
  template {
    display: none;
  }
  a {
    background-color: transparent;
  }
  a:active,
  a:hover {
    outline: 0;
  }
  abbr[title] {
    border-bottom: 1px dotted;
  }
  b,
  strong {
    font-weight: 700;
  }
  dfn {
    font-style: italic;
  }
  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }
  mark {
    background: #ff0;
    color: #000;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sup {
    top: -0.5em;
  }
  sub {
    bottom: -0.25em;
  }
  img {
    border: 0;
  }
  svg:not(:root) {
    overflow: hidden;
  }
  figure {
    margin: 1em 40px;
  }
  hr {
    -moz-box-sizing: content-box;
    box-sizing: content-box;
    height: 0;
  }
  pre {
    overflow: auto;
  }
  code,
  kbd,
  pre,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    color: inherit;
    font: inherit;
    margin: 0;
  }
  button {
    overflow: visible;
  }
  button,
  select {
    text-transform: none;
  }
  button,
  html input[type="button"],
  input[type="reset"],
  input[type="submit"] {
    -webkit-appearance: button;
    cursor: pointer;
  }
  button[disabled],
  html input[disabled] {
    cursor: default;
  }
  button::-moz-focus-inner,
  input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
  input {
    line-height: normal;
  }
  input[type="checkbox"],
  input[type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    height: auto;
  }
  input[type="search"] {
    -webkit-appearance: textfield;
    -moz-box-sizing: content-box;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
  }
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  fieldset {
    border: 1px solid silver;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
  }
  legend {
    border: 0;
    padding: 0;
  }
  textarea {
    overflow: auto;
  }
  optgroup {
    font-weight: 700;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  td,
  th {
    padding: 0;
  }
  
  </style>
  